// API configuration for Vite React application
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7237/api/';
